<!-- Component for Filtering based on Product Tags -->
<template>
	<div class="swiper-no-swiping w-full">
		<Listbox
			as="div"
			v-model="selectedTag"
			class="w-full text-left"
			v-slot="{ open }"
		>
			<ListboxButton
				type="button"
				class="swiper-no-swiping group text-primary-700 flex w-full cursor-pointer items-center justify-between rounded-md border bg-white p-3 font-medium focus:outline-hidden"
				:class="open ? 'border-primary-700' : 'border-slate-300'"
			>
				{{ selectedLabel }}
				<PlayIcon
					class="group-hover:text-primary-700 h-4 w-4 text-xs transition-transform duration-100"
					:class="
						open ? 'text-primary-700 rotate-90' : '-rotate-90 text-slate-500'
					"
				/>
			</ListboxButton>
			<transition
				leave-active-class="transition ease-in duration-100"
				leave-from-class="opacity-100"
				leave-to-class="opacity-0"
			>
				<ListboxOptions
					class="border-primary-700 absolute left-0 z-50 mt-2 w-full rounded-md border bg-white font-medium shadow-lg focus:outline-hidden"
				>
					<ListboxOption
						v-for="tag in productTags"
						:key="tag.id"
						:value="tag"
						as="template"
						v-slot="{ active, selected }"
						class="last:rounded-b-md"
					>
						<li
							class="cursor-pointer rounded-md p-4 text-slate-900"
							:class="active || selected ? 'bg-slate-100' : ''"
						>
							{{ tag.name }}
						</li>
					</ListboxOption>
				</ListboxOptions>
			</transition>
		</Listbox>
	</div>
</template>

<script setup lang="ts">
import type { SfTag } from '@/apiTypes'
import {
	Listbox,
	ListboxButton,
	ListboxOption,
	ListboxOptions,
} from '@headlessui/vue'
import { PlayIcon } from '@heroicons/vue/24/solid'
import { computed, type PropType, ref, watch } from 'vue'

const props = defineProps({
	productTags: {
		type: Array as PropType<SfTag[]>,
		required: true,
	},
})

const emit = defineEmits<{
	select: [tag: SfTag]
}>()

const selectedTag = ref<SfTag | null>(null)
const selectedLabel = computed(
	() => selectedTag.value?.name ?? props.productTags[0]?.name ?? ''
)

watch(selectedTag, (tag) => {
	if (!tag) return
	emit('select', tag)
})
</script>
